import { useEffect, useMemo, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Pagination, Segmented } from "antd";
import { isSuperAdminByToken } from "@/shared/lib/session-service";
import { getRefreshTokenFromOldAccess } from "@entities/api/auth-middleware/utils";
import {
  useOrganizationIntegrations,
  useOrganization,
} from "@entities/organization";
import { projectQueries } from "@entities/project";
import { ProjectPageSkeleton } from "../index";
import { ProjectList } from "./project-list";
import { Empty } from "./projectempty";
import "./projects-page.scss";

const ProjectsPage = () => {
  const [mode, setMode] = useState<"modern" | "legacy">("legacy");
  const [page, setPage] = useState({ modern: 1, legacy: 1 });
  const { update, integrations } = useOrganizationIntegrations();
  const { data: organization } = useOrganization();

  useEffect(() => {
    const getAndDecodeToken = async () => {
      try {
        const legacyAccessTokenLocal = localStorage.getItem("token");
        const accessTokenLocal = localStorage.getItem("newToken");

        let tokenToDecode = accessTokenLocal;

        if (legacyAccessTokenLocal && !accessTokenLocal) {
          const { accessToken } = await getRefreshTokenFromOldAccess(legacyAccessTokenLocal);
          if (accessToken) {
            localStorage.setItem("newToken", accessToken);
            tokenToDecode = accessToken;
          }
        }

        if (tokenToDecode && isSuperAdminByToken(tokenToDecode)) {
          update(["builddocs2"], true);
        }
      } catch {
        // token decode failed
      }
    };

    getAndDecodeToken();
  }, [update]);

  useEffect(() => {
    if (organization?.integrations?.includes("BUILDDOCS2")) {
      update(["builddocs2"], true);
    }
  }, [organization, update]);

  const [segmentedOptions, setSegmentedOptions] = useState<
    { value: string; label: string }[]
  >([
    {
      value: "legacy",
      label: "Проекты раздела ИД",
    },
  ]);
  const { data: projects, isLoading } = useQuery({
    ...projectQueries.getProjects({
      page: page.modern,
      limit: 20,
    }),
    enabled: mode === "modern",
  });

  const { data: projectsLegacy, isLoading: isLoadingLegacy } = useQuery({
    ...projectQueries.getProjectsLegacy({
      pageSize: 20,
      pageNumber: page.legacy - 1,
    }),
    enabled: mode === "legacy",
  });

  useEffect(() => {
    if (integrations.builddocs2) {
      setSegmentedOptions((prevState) => [
        prevState?.[0],
        {
          value: "modern",
          label: "Проекты раздела ОЖР",
        },
      ]);
    }
  }, [integrations]);

  const projectListItems =
    mode === "modern" ? projects?.projects : projectsLegacy?.entityList;

  const pageCount =
    mode === "modern"
      ? (projects?.total ?? 0) / (projects?.limit ?? 1)
      : (projectsLegacy?.pageCount ?? 1);

  let mainElement = <></>;
  if (mode === "modern" ? isLoading : isLoadingLegacy) {
    mainElement = <ProjectPageSkeleton />;
  } else if (projectListItems?.length && projectListItems.length > 0) {
    mainElement = <ProjectList projects={projectListItems} mode={mode} />;
  } else {
    mainElement = <Empty />;
  }

  const memoizedSegmented = useMemo(
    () => (
      <Segmented<"modern" | "legacy">
        // TODO
        // @ts-expect-error options Segmented не совпадают с типом value
        options={segmentedOptions}
        onChange={setMode}
        value={mode}
        size="large"
        className="projects-page-menu-segmented"
        style={{
          backgroundColor: "#F0F2F5",
          borderRadius: "16px",
          color: "#1F1F1F !important",
        }}
      />
    ),
    [segmentedOptions, mode],
  );

  const onPageChange = (val: number) => {
    setPage((page) => ({ ...page, [mode]: val }));
  };

  return (
    <div className="projects-page">
      <div className="projects-page-menu">
        {memoizedSegmented}
      </div>
      {mainElement}
      {pageCount > 1 && (
        <div className="projects-page-pagination">
          <Pagination
            current={mode === "legacy" ? page.legacy : page.modern}
            total={pageCount * 20}
            pageSize={20}
            onChange={onPageChange}
          />
        </div>
      )}
    </div>
  );
};

export default ProjectsPage;
